/*
================================================================================
File: src/components/common/PageContent.js
Description: A wrapper component for page content, providing a consistent layout.
================================================================================
*/

const PageContent = ({
  children,
  title,
  subtitle,
  thirdtitle,
  fourthtitle,
  error,
}) => (
  <div className="min-h-screen bg-white dark:bg-gray-900 font-sans ">
    {/* <div className="flex px-5 py-3 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 m-10">
      <ol className="inline-flex items-center space-x-1 md:space-x-2">
        <li className="inline-flex items-center">
            <svg fill="currentColor" width="18" height="18" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" className="jam jam-home mr-2">
              <path d="M18 18V7.132l-8-4.8-8 4.8V18h4v-2.75a4 4 0 1 1 8 0V18h4zm-6 2v-4.75a2 2 0 1 0-4 0V20H2a2 2 0 0 1-2-2V7.132a2 2 0 0 1 .971-1.715l8-4.8a2 2 0 0 1 2.058 0l8 4.8A2 2 0 0 1 20 7.132V18a2 2 0 0 1-2 2h-6z" />
            </svg>
            Big Dog Tools
        </li>
        {title && (
            <li>
                <div className="flex items-center">
                    <svg className="rtl:rotate-180 block w-3 h-3 mx-1 text-gray-400 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/></svg>
                    <p className="font-extrabold">{title}</p>
                </div>
            </li>
        )}
        {subtitle && (
            <li>
                <div className="flex items-center">
                    <svg className="rtl:rotate-180 block w-3 h-3 mx-1 text-gray-400 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/></svg>
                    <p className="font-extrabold">{subtitle}</p>
                </div>
            </li>
        )}
        {thirdtitle && (
            <li>
                <div className="flex items-center">
                    <svg className="rtl:rotate-180 block w-3 h-3 mx-1 text-gray-400 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/></svg>
                    <p className="font-extrabold">{thirdtitle}</p>
                </div>
            </li>
        )}
        {fourthtitle && (
            <li>
                <div className="flex items-center">
                    <svg className="rtl:rotate-180 block w-3 h-3 mx-1 text-gray-400 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/></svg>
                    <p className="font-extrabold">{fourthtitle}</p>
                </div>
            </li>
        )}
      </ol>
    </div> */}
    <div className="flex items-center justify-center">
      {error && (
        <div role="alert" aria-live="polite" className="w-1/2">
          <div className="bg-red-500 text-white font-bold rounded-t px-4 py-2 justify-center">
            Alert: Something not so ideal just occured.
          </div>
          <div className="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700 ">
            <p>{error}</p>
          </div>
        </div>
      )}
    </div>
    {children}
  </div>
);

export default PageContent;
